import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, FlaskConical } from "lucide-react";

const navLinks = [
  { label: "Master Guide", path: "/" },
  { label: "Clinical Data", path: "/clinical-data" },
  { label: "Compare GLP-1s", path: "/compare" },
  { label: "Dosage Calculator", path: "/dosage-calc" },
  { label: "Blog", path: "/blog" },
];

export default function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full glass border-b border-slate-200/60 shadow-nav"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link
            to="/"
            data-testid="site-logo"
            className="flex items-center gap-2.5 group"
          >
            <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-sky-500 to-sky-700 flex items-center justify-center shadow-sm">
              <FlaskConical className="h-4 w-4 text-white" strokeWidth={2} />
            </div>
            <div className="flex flex-col leading-none">
              <span className="text-[15px] font-bold text-slate-900 tracking-tight">
                RetatrutideGuide
              </span>
              <span className="text-[10px] tracking-wide uppercase text-slate-400 font-medium">
                Research Resource
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav
            data-testid="desktop-nav"
            className="hidden md:flex items-center gap-1 bg-slate-100/80 rounded-full px-1.5 py-1"
          >
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.path.replace(/\//g, "").replace(/-/g, "-") || "home"}`}
                  className={`px-4 py-1.5 text-[13px] font-medium rounded-full transition-all duration-200 ${
                    isActive
                      ? "bg-white text-slate-900 shadow-sm"
                      : "text-slate-500 hover:text-slate-900"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>

          {/* Mobile toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2 text-slate-500 hover:text-slate-900 rounded-xl hover:bg-slate-100 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle navigation menu"
          >
            {mobileOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileOpen && (
          <nav
            data-testid="mobile-nav"
            className="md:hidden border-t border-slate-200/60 py-3 space-y-1"
          >
            {navLinks.map((link) => {
              const isActive = location.pathname === link.path;
              return (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.path.replace(/\//g, "").replace(/-/g, "-") || "home"}`}
                  onClick={() => setMobileOpen(false)}
                  className={`block px-4 py-2.5 text-sm font-medium rounded-xl transition-colors ${
                    isActive
                      ? "bg-slate-100 text-slate-900"
                      : "text-slate-500 hover:text-slate-900 hover:bg-slate-50"
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </nav>
        )}
      </div>
    </header>
  );
}
